/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-sidebar.scss'
import template from 'lui-sidebar.html'

export default class LuiSidebar extends LuiBase {
  static get is() {
    return 'lui-sidebar'
  }

  static get cssClassToggles() {
    return ['brand']
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get attributeToggles() {
    return ['sidebarwidth', 'openwidth', 'panelheight']
  }

  onConnected() {
    if (this.sidebarChevron) {
      this.sidebarChevron.addEventListener('click', event => this.toggleChevron(event))
    }
  }

  onDisconnected() {
    this.sidebarChevron.removeEventListener('click', this.toggleChevron)
  }

  get sidebarChevron() {
    return this.shadowRoot.querySelector('.lui-chevron-right')
  }
  get panelheight() {
    return this._panelheight || (this._panelheight = this.getAttribute('panelheight'))
  }

  toggleChevron(event) {
    this.sidebarChevron.classList.toggle('css-transform')
    const panel = this.shadowRoot.querySelector('.lui-sidebar-panel')
    panel.classList.toggle('lui-sidebar-panel__show')
    panel.style.height = this.panelheight
  }

  sidebarwidthChanged(oldValue, newValue) {
    const luiSidebar = this.luiSidebarControl
    luiSidebar.style.width = newValue
    this.sidebarChevron.style.width = newValue
    this.shadowRoot.querySelector('.lui-logo').style.width = newValue
  }

  panelwidthChanged(oldValue, newValue) {
    this.shadowRoot.querySelector('.lui-sidebar-panel').style.width = newValue
  }

  panelheightChanged(oldValue, newValue) {
    this.shadowRoot.querySelector('.lui-sidebar-panel').style.height = newValue
  }

  get luiSidebarControl() {
    return this.shadowRoot.querySelector('.lui-sidebar')
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-sidebar/lui-sidebar.js
// module id = 314
// module chunks = 0 1 27